module.exports = __webpack_public_path__ + "static/img/images-mail@3x.23396215.png";